export default __webpack_public_path__ + "static/media/features_card2.3f4a112c.svg";